import React, { useState, useEffect } from "react";
import styled from "styled-components";
import _ from "lodash";

import Slider from "react-slick";
import Modal from "../../components/Modal";

import officePhoto11 from "../../assets/1/officeMain01.webp";
import officePhoto12 from "../../assets/1/officeMain03.webp";
import officePhoto13 from "../../assets/1/officeMain04.webp";
import officePhoto14 from "../../assets/1/officeMain05.webp";
import officePhoto15 from "../../assets/1/officeMain06.webp";
import officePhoto16 from "../../assets/1/officeMain07.webp";
import officePhoto17 from "../../assets/1/officeMain08.webp";
import officePhoto18 from "../../assets/1/officeMain10.webp";
import officePhoto19 from "../../assets/1/officeMain12.webp";

import officePhoto21 from "../../assets/2/pt_main01.webp";
import officePhoto22 from "../../assets/2/entrance.webp";
import officePhoto23 from "../../assets/2/study2people2.webp";
import officePhoto24 from "../../assets/2/officeMain02.webp";
import officePhoto25 from "../../assets/2/kiosk.webp";
import officePhoto26 from "../../assets/2/printer.webp";
import officePhoto27 from "../../assets/2/cafeteria.webp";
import officePhoto28 from "../../assets/2/study2people1.webp";
import officePhoto29 from "../../assets/2/womenforone.webp";

import officePhoto31 from "../../assets/3/office11.webp";
import officePhoto32 from "../../assets/3/office02.webp";
import officePhoto33 from "../../assets/3/office03.webp";
import officePhoto34 from "../../assets/3/office05.webp";
import officePhoto35 from "../../assets/3/office06.webp";
import officePhoto36 from "../../assets/3/office07.webp";
import officePhoto37 from "../../assets/3/office08.webp";
import officePhoto38 from "../../assets/3/officeblock01.webp";
import officePhoto39 from "../../assets/3/cctv.webp";

import officePhoto41 from "../../assets/4/office01.webp";
import officePhoto42 from "../../assets/4/office02.webp";
import officePhoto43 from "../../assets/4/office03.webp";
import officePhoto44 from "../../assets/4/office04.webp";
import officePhoto45 from "../../assets/4/office05.webp";
import officePhoto46 from "../../assets/4/office06.webp";
import officePhoto47 from "../../assets/4/office07.webp";
import officePhoto48 from "../../assets/4/office08.webp";
import officePhoto49 from "../../assets/4/office09.webp";
import officePhoto411 from "../../assets/4/office11.webp";
import officePhoto421 from "../../assets/4/office12.webp";
import officePhoto431 from "../../assets/4/office13.webp";
import officePhoto451 from "../../assets/4/office15.webp";
import officePhoto461 from "../../assets/4/office16.webp";
import officePhoto471 from "../../assets/4/office17.webp";
import officePhoto481 from "../../assets/4/office18.webp";
import officePhoto491 from "../../assets/4/office19.webp";
import officePhoto412 from "../../assets/4/common01.webp";
import officePhoto422 from "../../assets/4/common02.webp";
import officePhoto432 from "../../assets/4/common03.webp";
import officePhoto442 from "../../assets/4/common04.webp";

// bugae
import officePhoto61 from "../../assets/6/bugae1.webp";
import officePhoto62 from "../../assets/6/bugae2.webp";
import officePhoto63 from "../../assets/6/bugae3.webp";
import officePhoto64 from "../../assets/6/bugae4.webp";

// yongam
import officePhoto71 from "../../assets/7/office_01.webp";
import officePhoto72 from "../../assets/7/office_02.webp";
import officePhoto73 from "../../assets/7/office_03.webp";
import officePhoto74 from "../../assets/7/office_04.webp";
import officePhoto75 from "../../assets/7/office_05.webp";
import officePhoto76 from "../../assets/7/office_06.webp";
import officePhoto77 from "../../assets/7/office_07.webp";
import officePhoto78 from "../../assets/7/office_08.webp";
import officePhoto79 from "../../assets/7/office_09.webp";
import officePhoto710 from "../../assets/7/office_10.webp";

// anyang
import officePhoto81 from "../../assets/8/photo-1.webp";
import officePhoto82 from "../../assets/8/photo-2.webp";
import officePhoto83 from "../../assets/8/photo-3.webp";
import officePhoto84 from "../../assets/8/photo-4.webp";
import officePhoto85 from "../../assets/8/photo-5.webp";
import officePhoto86 from "../../assets/8/photo-6.webp";
import officePhoto87 from "../../assets/8/photo-7.webp";
import officePhoto88 from "../../assets/8/photo-8.webp";
import officePhoto89 from "../../assets/8/photo-9.webp";

// jeongwang
import officePhoto91 from "../../assets/9/picture_1.webp";
import officePhoto92 from "../../assets/9/picture_2.webp";
import officePhoto93 from "../../assets/9/picture_3.webp";
import officePhoto94 from "../../assets/9/picture_4.webp";
import officePhoto95 from "../../assets/9/picture_5.webp";
import officePhoto96 from "../../assets/9/picture_6.webp";
import officePhoto97 from "../../assets/9/picture_7.webp";
import officePhoto98 from "../../assets/9/picture_8.webp";
import officePhoto99 from "../../assets/9/picture_9.webp";
import officePhoto910 from "../../assets/9/picture_10.webp";
import officePhoto911 from "../../assets/9/picture_11.webp";
import officePhoto912 from "../../assets/9/picture_12.webp";
import officePhoto913 from "../../assets/9/picture_13.webp";
import officePhoto914 from "../../assets/9/picture_14.webp";
import officePhoto915 from "../../assets/9/picture_15.webp";
import officePhoto916 from "../../assets/9/picture_16.webp";

import officePhoto101 from "../../assets/10/photo_1.webp";
import officePhoto102 from "../../assets/10/photo_2.webp";
import officePhoto103 from "../../assets/10/photo_3.webp";
import officePhoto104 from "../../assets/10/photo_4.webp";
import officePhoto105 from "../../assets/10/photo_5.webp";
import officePhoto106 from "../../assets/10/photo_6.webp";
import officePhoto107 from "../../assets/10/photo_7.webp";
import officePhoto108 from "../../assets/10/photo_8.webp";
import officePhoto109 from "../../assets/10/photo_9.webp";
import officePhoto1010 from "../../assets/10/photo_10.webp";
import officePhoto1011 from "../../assets/10/photo_11.webp";
import officePhoto1012 from "../../assets/10/photo_12.webp";
import officePhoto1013 from "../../assets/10/photo_13.webp";
import officePhoto1014 from "../../assets/10/photo_14.webp";
import officePhoto1015 from "../../assets/10/photo_15.webp";
import officePhoto1016 from "../../assets/10/photo_16.webp";
import officePhoto1017 from "../../assets/10/photo_17.webp";
import officePhoto1018 from "../../assets/10/photo_18.webp";
import officePhoto1019 from "../../assets/10/printer.webp";
import officePhoto1020 from "../../assets/10/coffee.webp";

//gyeyang
import officePhoto1101 from '../../assets/11/pic01.webp'
import officePhoto1102 from '../../assets/11/pic02.webp';
import officePhoto1103 from '../../assets/11/pic03.webp';
import officePhoto1104 from '../../assets/11/pic04.webp';
import officePhoto1105 from '../../assets/11/pic05.webp';
import officePhoto1106 from '../../assets/11/pic06.webp';
import officePhoto1107 from '../../assets/11/pic07.webp';
import officePhoto1108 from '../../assets/11/pic08.webp';
import officePhoto1109 from '../../assets/11/pic09.webp';

import officePhoto1201 from '../../assets/12/bd_entrance.webp';
import officePhoto1202 from '../../assets/12/bd_aisle.webp';
import officePhoto1203 from '../../assets/12/bd_non_resident.webp';
import officePhoto1204 from '../../assets/12/bd_main.webp';
import officePhoto1205 from '../../assets/12/bd_shared_computer.webp';
import officePhoto1206 from '../../assets/12/bd_single_seat.webp';
import officePhoto1207 from '../../assets/12/bd_single_room.webp';
import officePhoto1208 from '../../assets/12/bd_double_room.webp';
import officePhoto1209 from '../../assets/12/bd_triple_room.webp';
import officePhoto1210 from '../../assets/12/bd_entrance_inside.webp';


import officePhoto1301 from '../../assets/13/ap_01.webp';
import officePhoto1302 from '../../assets/13/ap_02.webp';
import officePhoto1303 from '../../assets/13/ap_03.webp';
import officePhoto1304 from '../../assets/13/ap_04.webp';
import officePhoto1305 from '../../assets/13/ap_05.webp';
import officePhoto1306 from '../../assets/13/ap_06.webp';
import officePhoto1307 from '../../assets/13/ap_07.webp';
import officePhoto1308 from '../../assets/13/ap_08.webp';
import officePhoto1309 from '../../assets/13/ap_09.webp';
import officePhoto1310 from '../../assets/13/ap_10.webp';

//amsa
import officePhoto1401 from '../../assets/14/as_01.webp';
import officePhoto1402 from '../../assets/14/as_02.webp';
import officePhoto1403 from '../../assets/14/as_03.webp';
import officePhoto1404 from '../../assets/14/as_04.webp';
import officePhoto1405 from '../../assets/14/as_05.webp';
import officePhoto1406 from '../../assets/14/as_06.webp';
import officePhoto1407 from '../../assets/14/as_07.webp';

//baegot
import officePhoto1501 from "../../assets/15/pic_01.webp";
import officePhoto1502 from "../../assets/15/pic_02.webp";
import officePhoto1503 from "../../assets/15/pic_03.webp";
import officePhoto1504 from "../../assets/15/pic_04.webp";
import officePhoto1505 from "../../assets/15/pic_05.webp";
import officePhoto1506 from "../../assets/15/pic_06.webp";
import officePhoto1507 from "../../assets/15/pic_07.webp";
import officePhoto1508 from "../../assets/15/pic_08.webp";
import officePhoto1509 from "../../assets/15/pic_09.webp";
import officePhoto1510 from "../../assets/15/pic_10.webp";
import officePhoto1511 from "../../assets/15/pic_11.webp";
import officePhoto1512 from "../../assets/15/pic_12.webp";
import officePhoto1513 from "../../assets/15/pic_13.webp";
import officePhoto1514 from "../../assets/15/pic_14.webp";
import officePhoto1515 from "../../assets/15/pic_15.webp";
import officePhoto1516 from "../../assets/15/pic_16.webp";
import officePhoto1517 from "../../assets/15/pic_17.webp";
import officePhoto1518 from "../../assets/15/pic_18.webp";

//hakik
import officePhoto1601 from "../../assets/16/hk_01.webp";
import officePhoto1602 from "../../assets/16/hk_02.webp";
import officePhoto1603 from "../../assets/16/hk_03.webp";
import officePhoto1604 from "../../assets/16/hk_04.webp";
import officePhoto1605 from "../../assets/16/hk_05.webp";
import officePhoto1606 from "../../assets/16/hk_06.webp";
import officePhoto1607 from "../../assets/16/hk_07.webp";
import officePhoto1608 from "../../assets/16/hk_08.webp";
import officePhoto1609 from "../../assets/16/hk_09.webp";

//seouluni
import officePhoto1718 from "../../assets/17/sw_01.webp";
import officePhoto1702 from "../../assets/17/sw_02.webp";
import officePhoto1703 from "../../assets/17/sw_03.webp";
import officePhoto1704 from "../../assets/17/sw_04.webp";
import officePhoto1705 from "../../assets/17/sw_05.webp";
import officePhoto1706 from "../../assets/17/sw_06.webp";
import officePhoto1707 from "../../assets/17/sw_07.webp";
import officePhoto1708 from "../../assets/17/sw_08.webp";
import officePhoto1709 from "../../assets/17/sw_09.webp";
import officePhoto1710 from "../../assets/17/sw_10.webp";
import officePhoto1711 from "../../assets/17/sw_11.webp";
import officePhoto1712 from "../../assets/17/sw_12.webp";
import officePhoto1713 from "../../assets/17/sw_13.webp";
import officePhoto1714 from "../../assets/17/sw_14.webp";
import officePhoto1715 from "../../assets/17/sw_15.webp";
import officePhoto1716 from "../../assets/17/sw_16.webp";
import officePhoto1717 from "../../assets/17/sw_17.webp";
import officePhoto1701 from "../../assets/17/sw_18.webp";

// jakjeon
import officePhoto2101 from '../../assets/21/pic01.webp'
import officePhoto2102 from '../../assets/21/pic02.webp';
import officePhoto2103 from '../../assets/21/pic03.webp';
import officePhoto2104 from '../../assets/21/pic04.webp';
import officePhoto2105 from '../../assets/21/pic05.webp';
import officePhoto2106 from '../../assets/21/pic06.webp';
import officePhoto2107 from '../../assets/21/pic07.webp';
import officePhoto2108 from '../../assets/21/pic08.webp';
import officePhoto2109 from '../../assets/21/pic09.webp';

// bangi
import officePhoto2401 from '../../assets/24/pic01.webp'
import officePhoto2402 from '../../assets/24/pic02.webp';
import officePhoto2403 from '../../assets/24/pic03.webp';
import officePhoto2404 from '../../assets/24/pic04.webp';
import officePhoto2405 from '../../assets/24/pic05.webp';
import officePhoto2406 from '../../assets/24/pic06.webp';
import officePhoto2407 from '../../assets/24/pic07.webp';
import officePhoto2408 from '../../assets/24/pic08.webp';
import officePhoto2409 from '../../assets/24/pic09.webp';
import officePhoto2410 from '../../assets/24/pic10.webp';
import officePhoto2411 from '../../assets/24/pic11.webp';
import officePhoto2412 from '../../assets/24/pic12.webp';

// yullyang
import officePhoto2601 from '../../assets/26/pic01.webp'
import officePhoto2602 from '../../assets/26/pic02.webp';
import officePhoto2603 from '../../assets/26/pic03.webp';
import officePhoto2604 from '../../assets/26/pic04.webp';
import officePhoto2605 from '../../assets/26/pic05.webp';
import officePhoto2606 from '../../assets/26/pic06.webp';
import officePhoto2607 from '../../assets/26/pic07.webp';
import officePhoto2608 from '../../assets/26/pic08.webp';
import officePhoto2609 from '../../assets/26/pic09.webp';
import officePhoto2610 from '../../assets/26/pic10.webp';
import officePhoto2611 from '../../assets/26/pic11.webp';
import officePhoto2612 from '../../assets/26/pic12.webp';

import newLogo from '../../assets/logo_new.webp'

import { useBranch } from "../../contexts/BranchContext";
import Subject from "../../components/Subject";

const Wrapper = styled.div`
  width: 100%;
  height: auto;

  @media (max-width: 1250px) {
    height: auto;
    padding-top: 2rem;
  }
`;

const Inner = styled.div`
  width: 70%;
  height: 100%;
  margin: auto;
  padding: 4rem 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border-top: ${({ theme }) => theme.boxBorder};

  @media (max-width: 1250px) {
    flex-direction: column;
    width: 80%;
    height: auto;
  }

  .webPhoto{
    width: 32.1%;
    height: 13rem;
    position: relative;
    margin: calc(100% - 33.2%*3) 0;
    border-radius: 0.5rem;
    cursor: pointer;
    overflow: hidden;

    :nth-child(3),
    :nth-child(6),
    :nth-child(9) {
      margin-left: 1rem;
      margin-right:1rem;
    }

   

    

    @media (max-width: 1250px) {
        border : 1px solid red;
        display: none;
    }

    > img {
      width: 100%;
      height: 100%;

      object-fit: cover;
      transition: 0.5s;

      &:hover {
        transform: scale(1.1);
      }
    }
  }
  
`;

const SliderWrapper = styled.div`
  display: none;
  @media (max-width: 1250px) {
    display: block;
    width: 100%;
    /* overflow: hidden; */
    
    .sliderImg{
      width: 100%;
      height: 70vh !important;
      overflow: hidden;

      img{
        width: 100%;
        height: 100% !important;
        object-fit: cover !important;
      }
    }
  }
`;


function PhotoZone() {
  const [isOpen, setOpen] = useState(false);
  const [current, setCurrent] = useState(0);
  const [branch, _] = useBranch();
  const photos: { [key: string]: string[] } = {
    "onedang": [
      officePhoto11,
      officePhoto12,
      officePhoto13,
      officePhoto14,
      officePhoto15,
      officePhoto16,
      officePhoto17,
      officePhoto18,
      officePhoto19,
    ], "pyeongtaek": [
      officePhoto21,
      officePhoto22,
      officePhoto23,
      officePhoto24,
      officePhoto25,
      officePhoto26,
      officePhoto27,
      officePhoto28,
      officePhoto29,
    ], "yeongdeungpo": [
      officePhoto31,
      officePhoto32,
      officePhoto33,
      officePhoto34,
      officePhoto35,
      officePhoto36,
      officePhoto37,
      officePhoto38,
      officePhoto39,
    ], "wonju": [
      officePhoto41,
      officePhoto42,
      officePhoto43,
      officePhoto44,
      officePhoto45,
      officePhoto46,
      officePhoto47,
      officePhoto48,
      officePhoto49,
      officePhoto411,
      officePhoto421,
      officePhoto431,
      officePhoto451,
      officePhoto461,
      officePhoto471,
      officePhoto481,
      officePhoto491,
      officePhoto412,
      officePhoto422,
      officePhoto432,
      officePhoto442,
    ],
    "daegu": [],
    "bugae": [
      officePhoto61,
      officePhoto62,
      officePhoto63,
      officePhoto64,
    ],
    "yongam": [
      officePhoto71,
      officePhoto72,
      officePhoto73,
      officePhoto74,
      officePhoto75,
      officePhoto76,
      officePhoto77,
      officePhoto78,
      officePhoto79,
      officePhoto710,
    ],
    "anyang": [
      officePhoto81,
      officePhoto82,
      officePhoto83,
      officePhoto84,
      officePhoto85,
      officePhoto86,
      officePhoto87,
      officePhoto88,
      officePhoto89,
    ],
    "jeongwang": [
      officePhoto91,
      officePhoto92,
      officePhoto93,
      officePhoto94,
      officePhoto95,
      officePhoto96,
      officePhoto97,
      officePhoto98,
      officePhoto99,
      officePhoto910,
      officePhoto911,
      officePhoto912,
      officePhoto913,
      officePhoto914,
      officePhoto915,
      officePhoto916,
    ],
    "yongsan": [
      officePhoto101,
      officePhoto102,
      officePhoto103,
      officePhoto104,
      officePhoto105,
      officePhoto106,
      officePhoto107,
      officePhoto108,
      officePhoto109,
      officePhoto1010,
      officePhoto1011,
      officePhoto1012,
      officePhoto1013,
      officePhoto1014,
      officePhoto1015,
      officePhoto1016,
      officePhoto1017,
      officePhoto1018,
      officePhoto1019,
      officePhoto1020,
    ],
    "gyeyang": [
      officePhoto1101,
      officePhoto1102,
      officePhoto1103,
      officePhoto1104,
      officePhoto1105,
      officePhoto1106,
      officePhoto1107,
      officePhoto1108,
      officePhoto1109,

    ],
    "bokdae": [officePhoto1201,
      officePhoto1202,
      officePhoto1203,
      officePhoto1204,
      officePhoto1205,
      officePhoto1206,
      officePhoto1207,
      officePhoto1208,
      officePhoto1209,
      officePhoto1210,

    ],
    "apgujeong": [
      officePhoto1301,
      officePhoto1302,
      officePhoto1303,
      officePhoto1304,
      officePhoto1305,
      officePhoto1306,
      officePhoto1307,
      officePhoto1308,
      officePhoto1309,
      officePhoto1310
    ],
    "amsa": [
      officePhoto1401,
      officePhoto1402,
      officePhoto1403,
      officePhoto1404,
      officePhoto1405,
      officePhoto1406,
      officePhoto1407,
    ],
    "baegot": [
      newLogo,
      officePhoto1501,
      officePhoto1502,
      officePhoto1503,
      officePhoto1504,
      officePhoto1505,
      officePhoto1506,
      officePhoto1507,
      officePhoto1508,
      officePhoto1509,
      officePhoto1510,
      officePhoto1511,
      officePhoto1512,
      officePhoto1513,
      officePhoto1514,
      officePhoto1515,
      officePhoto1516,
      officePhoto1517,
      officePhoto1518,
    ],
    "hakik": [
      officePhoto1601,
      officePhoto1602,
      officePhoto1603,
      officePhoto1604,
      officePhoto1605,
      officePhoto1606,
      officePhoto1607,
      officePhoto1608,
      officePhoto1609,
    ],
    "seouluni": [
      officePhoto1701,
      officePhoto1702,
      officePhoto1703,
      officePhoto1704,
      officePhoto1705,
      officePhoto1706,
      officePhoto1707,
      officePhoto1708,
      officePhoto1709,
      officePhoto1710,
      officePhoto1711,
      officePhoto1712,
      officePhoto1713,
      officePhoto1714,
      officePhoto1715,
      officePhoto1716,
      officePhoto1717,
      officePhoto1718,
    ],
    "byeoryang": [
      officePhoto1701,
      officePhoto1702,
      officePhoto1703,
    ],
    "jakjeon": [
      officePhoto2101,
      officePhoto2102,
      officePhoto2103,
      officePhoto2104,
      officePhoto2105,
      officePhoto2106,
      officePhoto2107,
      officePhoto2108,
      officePhoto2109,
    ],
    "bangi": [officePhoto2401,
      officePhoto2402,
      officePhoto2403,
      officePhoto2404,
      officePhoto2405,
      officePhoto2406,
      officePhoto2407,
      officePhoto2408,
      officePhoto2409,
      officePhoto2410,
      officePhoto2411,
      officePhoto2412,

    ],
    "yullyang": [officePhoto2601,
      officePhoto2602,
      officePhoto2603,
      officePhoto2604,
      officePhoto2605,
      officePhoto2606,
      officePhoto2607,
      officePhoto2608,
      officePhoto2609,
      officePhoto2610,
      officePhoto2611,
      officePhoto2612,

    ],
  };
  const handleModal = (open: boolean) => {
    setOpen(open);
  };

  const settings = {
    arrows: true,
  };

  if (!photos[branch]) {
    return <div>해당 지점의 사진이 준비중입니다.</div>;
  }

  return (
    <Wrapper id="menu4">
      {branch !== "/" && <Inner>
        <Subject main="매장 사진" />
        {photos[branch]?.map((_, idx) => (
          <div
            className="webPhoto"
            key={idx}
            onClick={() => {
              handleModal(true);
              setCurrent(idx);
            }}
          >
            <img src={photos[branch][idx]} alt="office" />
          </div>
        ))}
        <SliderWrapper>
          <Slider dots {...settings}>
            {photos[branch]?.map((photo, index) => (
              <div className="sliderImg" key={index} onClick={() => {
                handleModal(true);
                setCurrent(index);
              }}>
                <img src={photo} alt="" />
              </div>
            ))}
          </Slider>
        </SliderWrapper>
      </Inner>
      }
      {branch !== "/" && isOpen ? (
        <Modal title={""} handleModal={handleModal} img={photos[branch][current]} />
      ) : null}
    </Wrapper>
  );
}
export default PhotoZone;
